import { SerializedStockClass } from '@commenda/types/src/cap-table/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useStockClasses(corporationId: number) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: SerializedStockClass[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `capTable/stockClass/byCorporationId/${corporationId}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
